export default __webpack_public_path__ + "static/media/DGAutoLtd-3.bb7a10bc.jpg";